/**
 * Customer Form Service
 * @author PBirudukota
 * @description Used post the application form
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { SalesrefService } from './salesref.service';


@Injectable({
  providedIn: 'root'
})
export class CustomerFormService {

  constructor(private http: HttpClient, private salesRefService: SalesrefService) {
  }

  /**
   * Submit Application Form
   * @param payload Payload
   */
  public submitForm(payload) {
    const salesId = this.salesRefService.refinfo.code;
    const newPayload = {...payload, "SALES_PERSON_ID": salesId}
    return this.http.post('/api/customers', newPayload);

  }

  public submitFormExisting(payload) {
    return this.http.post('/api/customers/existing', payload);
  }


  /**
   * Update Customer record
   * @param payload Payload
   */
  public updateForm(payload){

    let obj : any;

    obj = {APP:payload}

    return this.http.post('/api/updateCustomer', obj);
  }


    /**
   * Captcha Validation
   * @param payloads Payload
   */

  public validateCaptcha(payloads){

    return this.http.post('/api/captcha', payloads);
  }


  /**
   * Submit Application Form
   * @param body Payload
   * @param file File
   */
  public uploadDocs(file, body) {

    let formPayload = new FormData();
    formPayload.append('body', body);
    formPayload.append('file', file, body.DOC_NAME);
    return this.http.post('/api/documents', formPayload);
  }

}

